import axios from "axios";

export default axios.create( {
  // eslint-disable-next-line
  baseURL: process.env.VUE_APP_BASE_URL
} );